import { Button, Text } from '@mote/ui'
import { GenericRecorderErrorsTemplate } from './GenericRecorderErrorsTemplate'

export const AskForMicrophonePermissionError = ({ onClose }) => {
  return (
    <GenericRecorderErrorsTemplate
      onClose={onClose}
      header='Welcome to Mote!'
      content={
        <Text fontSize={15} lineHeight='120%' fontWeight={400}>
          Chrome is requesting microphone access on behalf of Mote. Click the
          "Allow" button to grant access.
        </Text>
      }
      buttons={
        <Button onClick={() => onClose()} variant='secondary' text='Got it' />
      }
    />
  )
}
